export default {
  cardText: {
    type: 'string',
    default: '',
  },
  cardButtonHref: {
    type: 'string',
    default: '',
  },
  icon: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  cardHasImg: {
    type: 'boolean',
    default: 'false',
  },
  background: {
    type: 'string',
    default: 'bg-blue',
  },
  cardHasDescription: {
    type: 'boolean',
    default: 'true',
  },
  descriptionCard: {
    type: 'string',
    default: '',
  },
  variant: {
    type: 'string',
    default: 'text-outside',
  },
};
